module.exports = __webpack_public_path__ + "img/VectorApp.95d939e4.svg";